import React, { lazy, useEffect, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa";
import flag_2 from "../assets/img/tarh-parcham-iran-psdtarh2.png";
import MainLayout from "../layout/main";
import { ApiEndpoints, useApiCall } from "../api";
import Loading from "../component/loading";
import { useTableDataGenerator } from "../helper/common";
import { appRoutes, useAppNavigation } from "../router/routes";
import { Table } from "../component/table";
import { SelectOption } from "../component/selectOption";
import { LIST_PAGE_SIZE } from "../config";
import { IoClose } from "react-icons/io5";
import { storageApi } from "../storage/storageApi";
import { useAlert } from "react-alert";
import { Input } from "../component/input";
import { confirmAlert } from "react-confirm-alert";
import { toDateString } from "../helper/dateHelper";

const BarnameList = () => {
  const { navigate, queryParameter } = useAppNavigation();
  const [cPage, setCPage] = useState(queryParameter().get("page"));
  const userProfile = storageApi.useGetUser();
  const [is_active, setIs_active] = useState(false);
  const [updateIs_active, setUpdateIs_active] = useState(false);
  const [title, setTitle] = useState("");
  const [id, setId] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const alert = useAlert();
  useEffect(() => {
    handleGetBarname();
  }, []);
  const handleGetBarname = () => {
    barnameList = handleFetchBarname();
  };
  useEffect(() => {
    if (cPage > 0) {
      handleFetchBarname();
    }
  }, [cPage]);
  let [[barnameList], { fetch: handleFetchBarname, loading }] = useApiCall({
    endpoints: [ApiEndpoints.barnameListByAdmin.List],
    payload: {
      page: cPage,
    },
  });
  console.log(barnameList);
  const [[profile]] = useApiCall({
    endpoints: [ApiEndpoints.user.profile],
  });
  const { data, setPage, currentPage, totalPageCount } = useTableDataGenerator(
    barnameList?.data.results ?? [],
    {
      filters: {},
    },
    barnameList?.data.count
  );
  const [, { loading: deleteLoading, fetch: handleDeleteBarname }] = useApiCall(
    {
      endpoints: ApiEndpoints.barnameListByAdmin.delete,
      payload: { id },
      lazy: true,
    }
  );
  const [, { loading: postLoading, fetch: handleAddBarname }] = useApiCall({
    endpoints: ApiEndpoints.barnameListByAdmin.addBarname,
    payload: { title, is_active },
    lazy: true,
  });
  const [, { loading: handleUpdateLoading, fetch: handleUpdateBarname }] =
    useApiCall({
      endpoints: [ApiEndpoints.barnameListByAdmin.updateBarname],
      payload: {
        title,
        updateIs_active,
        id,
      },
      lazy: true,
    });

  const onClickDelete = (i) => {
    confirmAlert({
      title: "",
      message: "آیا از حذف برنامه مطمئن هستید ؟",
      buttons: [
        {
          label: (
            <div>
              بله
              <Loading isLoading={loading} />
            </div>
          ),
          onClick: async () => {
            const [{ isOk }] = await handleDeleteBarname({
              id: i.id,
            });
            if (isOk) {
              window.location.reload();
            }
          },
        },
        {
          label: "خیر",
          onClick: () => {},
        },
      ],
    });
  };

  const setTablePage = (pageNumber) => {
    setCPage(pageNumber + 1);
  };
  const onChangeModalAdd = () => {
    setShowModal(true);
  };
  const onChangeModal = (i) => {
    setShowModalUpdate(true);
    setTitle(i.title);
    setUpdateIs_active(i.is_active);
    setId(i.id);
  };
  const hideModal = () => {
    setShowModal(false);
  };
  const hideModalUpdate = () => {
    setShowModalUpdate(false);
  };
  const submitForm = async () => {
    const [updateResult] = await handleAddBarname();
    if (updateResult.isOk) {
      alert.success("افزوده شد");
      handleGetBarname();
      hideModal();
    }
  };
  const submitFormUpdate = async () => {
    const [updateResult] = await handleUpdateBarname();
    if (updateResult.isOk) {
      alert.success("بروزرسانی موفق");
      handleGetBarname();
      hideModalUpdate();
    }
  };
  const handleCheckboxChange = () => {
    setIs_active(!is_active);
  };
  const handleUpdateCheckboxChange = () => {
    setUpdateIs_active(!updateIs_active);
  };

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto md:rounded-3xl rounded-xl relative p-8 md:min-h-[180px] min-h-[100px]">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-42 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="md:text-3xl text-xl text-center font-bold">
              <span className=" text-greenblue"> مدیریت برنامه ها </span>
            </div>
            {/* form search list */}
          </div>
        </div>
        <button
          onClick={() => onChangeModalAdd()}
          className="flex gap-1 bg-green-200 text-green-700 px-3 py-2 rounded-xl w-32 self-end"
        >
          افزودن
          <span className="mr-9">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </span>
        </button>
        <Table
          loading={loading}
          data={data}
          hasPagination
          totalPageCount={totalPageCount}
          totalCount={barnameList?.data.count}
          setPage={setTablePage}
          currentPage={currentPage}
          header={[
            {
              name: "ردیف",
              width: 1,
              render: (i) =>
                cPage == null
                  ? i.rowIndex
                  : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
            },
            {
              name: "برنامه",
              width: 2,
              render: (i) => i.title,
            },
            {
              name: "وضعیت",
              width: 2,
              render: (i) => (i.is_active ? "فعال" : "غیر فعال"),
            },
            {
              name: "تاریخ ایجاد",
              width: 2,
              render: (i) =>
                i.created === "-"
                  ? "-"
                  : toDateString(i.created, "jYYYY/jMM/jDD"),
            },
            {
              name: "اخرین تغییرات",
              width: 2,
              render: (i) =>
                i.last_modified === "-"
                  ? "-"
                  : toDateString(i.last_modified, "jYYYY/jMM/jDD"),
            },
            {
              name: "عملیات",
              width: 3,
              render: (i) => (
                <div className="flex gap-8">
                  {userProfile.role === "admin" && (
                    <button
                      onClick={() => onChangeModal(i)}
                      className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                    >
                      ویرایش
                    </button>
                  )}
                  <button
                    onClick={() => onClickDelete(i)}
                    className="flex items-center gap-1 bg-red-100 text-red-500 px-3 py-2 rounded-xl"
                  >
                    حذف
                  </button>
                </div>
              ),
            },
          ]}
        />
      </div>
      {showModal && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen  fixed top-0 left-0 overflow-y-scroll edit-modal`}
        >
          <div
            className="md:w-[768px] w-[350px] md:max-h-[900px] md:min-h-[400px]  rounded-xl p-8 bg-white absolute
           top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] flex align-center flex-col"
          >
            <div className=" text-center text-lg font-semibold mb-4 ">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModal}
              >
                <IoClose size={24} className="cursor-pointer" />
              </div>
              افزودن برنامه{" "}
            </div>
            <div className="flex f justify-center flex-col mt-10 w-full self-center">
              {userProfile.role === "admin" && (
                <>
                  <div className="w-full">
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="وارد کنید"
                        label="برنامه"
                        value={title}
                        onChange={(e) => {
                          setTitle(e);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <div>
                        <label className="rounded-xl">
                          <input
                            type="checkbox"
                            checked={is_active}
                            onChange={handleCheckboxChange}
                          />
                          فعال
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-center mt-10">
              <button
                onClick={submitForm}
                className="w-5/12 bg-green-600 text-white px-3 py-2 rounded-xl"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}
      {showModalUpdate && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen  fixed top-0 left-0 overflow-y-scroll edit-modal`}
        >
          <div
            className="md:w-[768px] w-[350px] md:max-h-[900px] md:min-h-[400px]  rounded-xl p-8 bg-white absolute
           top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] flex align-center flex-col"
          >
            <div className=" text-center text-lg font-semibold mb-4 ">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModalUpdate}
              >
                <IoClose size={24} className="cursor-pointer" />
              </div>
              ویرایش برنامه{" "}
            </div>
            <div className="flex f justify-center flex-col mt-10 w-full self-center">
              {userProfile.role === "admin" && (
                <>
                  <div className="w-full">
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="وارد کنید"
                        label="برنامه"
                        value={title}
                        onChange={(e) => {
                          setTitle(e);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <div>
                        <label className="rounded-xl">
                          <input
                            type="checkbox"
                            checked={updateIs_active}
                            onChange={handleUpdateCheckboxChange}
                          />
                          فعال
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-center mt-10">
              <button
                onClick={submitFormUpdate}
                className="w-5/12 bg-green-600 text-white px-3 py-2 rounded-xl"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default BarnameList;
